import useFiltersQuery from '../api/use-filters-query';
import { FiltersResponse, FiltersResponseKey, ModelFilterOption } from '../types/globalapi/filters';
import { ResponseSelector } from '../types/globalapi/response-selector';

export type Order = {
  bus: string[];
  suv: string[];
  compacts: string[];
  sedans: string[];
  previous: string[];
};

export const order: Order = {
  bus: ["idbuzz"],
  suv: ['taos', 'id4', 'tiguan', 'atlascrosssport', 'atlas'],
  compacts: ['golfgti', 'golfr'],
  sedans: ['jetta', 'jettagli'],
  previous: [
    'golf',
    'arteon',
    'egolf',
    'passat',
    'beetle',
    'golfsportwagen',
    'golfalltrack',
    'touareg',
    'cc',
    'eos',
  ],
};

export const typeHasInventory = (type: string) => {
  const getModelOptions: ResponseSelector<FiltersResponse, ModelFilterOption[]> = res => res[FiltersResponseKey.MODEL];
  const models = useFiltersQuery({select: getModelOptions}).data as ModelFilterOption[];

  if (!models) return;

  let hasInventory = false;

  models.forEach((model) => {
    hasInventory = hasInventory || model.vehicle_types.includes(type);
  });

  return hasInventory;
};
